(function (global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Lightbox = global.NewHomeSource.Lightbox || {};

  class Pagination {
    /**
     * Initializes a new instance of the class.
     * Sets the initial state to null.
     */
    constructor() {
      this.state = null;
      this.currentIndex = null;
      this.eventsToObserve = {
        itemsChange: this.itemsChange.bind(this),
      };
    }

    /**
     * Initializes the object with the given state.
     *
     * @param {Object} state - The state to initialize the object with.
     * @returns {this} The current instance for chaining.
     */
    initialize(state) {
      this.state = state;
      this.addObservers();
      return this;
    }

    /**
     * Registers this instance as an observer for each event specified in `eventsToObserve`.
     * Iterates over all event keys and adds this instance as an observer to the state for each event.
     */
    addObservers() {
      Object.keys(this.eventsToObserve).forEach((event) => this.state.addObserver(event, this));
    }

    getCurrentIndex() {
      const rootNode = this.state.get('rootNode');
      return rootNode.querySelector('[data-component="lightbox-current-index-element"]');
    }

    itemsChange(data) {
      if (this.currentIndex === data.currentIndex) {
        return;
      }
      this.currentIndex = data.currentIndex;
      const descriptionElement = this.getCurrentIndex();
      descriptionElement.textContent = data.currentIndex + 1;
    }

    /**
     * Updates the carousel by invoking the callback associated with the given topic.
     *
     * @param {*} data - The data to pass to the callback function.
     * @param {string} topic - The topic whose callback should be invoked.
     */
    update(data, topic) {
      const callback = this.eventsToObserve[topic];
      if (callback) {
        callback(data);
      }
    }

    /**
     * Removes this instance as an observer from all events listed in `eventsToObserve`.
     * Iterates over each event and calls `removeObserver` on the state object.
     */
    removeObservers() {
      Object.keys(this.eventsToObserve).forEach((event) => this.state.removeObserver(event, this));
    }

    /**
     * Cleans up resources by removing all observers associated with this instance.
     * Should be called to prevent memory leaks when the instance is no longer needed.
     */
    destroy() {
      this.removeObservers();
    }
  }

  global.NewHomeSource.Lightbox.Pagination = Pagination;
}(window));
